import styled from 'styled-components';

export const LotRulesSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const LotRulesBannerSlot = styled.div`
    margin-bottom: 0.5rem;
`;
